const faqItems = [
  {
    q: '布丁漫画的韩漫资源是否免费？',
    a: '是的，布丁漫画所有韩漫资源均为免费阅读，无需付费订阅或购买章节。我们通过广告合作维持运营，坚持为韩漫爱好者提供无障碍的阅读体验。每日更新的新章节同样免费开放。',
  },
  {
    q: '什么是下拉式阅读？如何使用？',
    a: '下拉式阅读是布丁漫画的核心阅读模式，读者只需向下滑动页面即可连续阅读完整章节，无需点击翻页按钮。这种设计模拟了韩国Webtoon平台的阅读习惯，适合手机和桌面端，让阅读体验更加流畅沉浸。',
  },
  {
    q: '韩漫的更新频率是怎样的？',
    a: '布丁漫画每日同步更新热门连载韩漫，日更作品超过200部。大部分热门连载作品保持每周更新1-2话的节奏，完结作品则一次性提供全集阅读。我们会在每部作品详情页标注更新状态。',
  },
  {
    q: '如何找到自己想看的韩漫？',
    a: '您可以通过首页的"推荐韩漫"卡片区浏览精选作品，也可以使用"韩漫排行"查看热度榜单，或通过"热门话题"按题材标签筛选感兴趣的作品。站内索引覆盖恋爱、奇幻、动作、悬疑等多元题材。',
  },
  {
    q: '布丁漫画支持哪些设备阅读？',
    a: '布丁漫画适配桌面电脑、平板和手机端浏览器，无需下载额外软件即可访问。移动端针对下拉式阅读做了专项优化，确保在小屏幕上也能获得舒适的阅读体验。',
  },
  {
    q: '是否支持离线下载或缓存阅读？',
    a: '目前布丁漫画为在线网页阅读平台，暂不支持离线下载功能。我们建议在Wi-Fi或移动网络环境下直接访问网站阅读，所有章节加载均经过流量优化，不影响浏览体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问答</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于布丁漫画韩漫阅读的常见问题，快速了解平台功能与使用方式
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <div className="mt-3 pl-9">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}